import { useRef } from "react";
import { SearchViewMode } from "../types";
export var useInitialResultStatus = function (initialResult) {
    var _a;
    return useRef({
        searchResult: (initialResult === null || initialResult === void 0 ? void 0 : initialResult.searchResult) != null,
        counts: (initialResult === null || initialResult === void 0 ? void 0 : initialResult.counts) != null,
        data: (_a = {},
            _a[SearchViewMode.MapView] = (initialResult === null || initialResult === void 0 ? void 0 : initialResult.placards) != null,
            _a[SearchViewMode.ListView] = (initialResult === null || initialResult === void 0 ? void 0 : initialResult.data) != null,
            _a[SearchViewMode.GalleryView] = (initialResult === null || initialResult === void 0 ? void 0 : initialResult.galleryItems) != null,
            _a),
    });
};
export var getDefaultInitialResultStatus = function () {
    var _a;
    return ({
        searchResult: false,
        counts: false,
        data: (_a = {},
            _a[SearchViewMode.MapView] = false,
            _a[SearchViewMode.ListView] = false,
            _a[SearchViewMode.GalleryView] = false,
            _a),
    });
};
//# sourceMappingURL=use-initial-result-status.js.map